import errorsController  from '@/utils/errorsController';
import {customInstanceAWS} from '@/http';
import { ZodGetCategories, GetCategories } from '@/types';
import { AppwriteException } from 'appwrite';
import { AxiosError } from 'axios';

export default async function getCategories(params?: GetCategories) {
  try {
		ZodGetCategories.parse(params)
		const queryParams = params ? new URLSearchParams(params).toString() : ''

    const { data } = await customInstanceAWS.get(`/categories?${queryParams}`);

    return data;
  } catch (error: AppwriteException | AxiosError | Error | unknown) {
    if (error instanceof AppwriteException || error instanceof AxiosError || error instanceof Error) {
      return errorsController(error, false);
    }
  }
}
